import { getCurrentUserInfo, User } from "@/services/api/user";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";
import { makeAutoObservable } from "mobx";

// https://github.com/mobxjs/mobx/blob/gh-pages/docs/refguide/api.md#configure
// configure({ enforceActions: true }); // mobx严格模式 不允许在action之外进行状态修改

class GlobalStore {
  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  async init(token: string) {
    AuthTokenHolder.setToken(token);

    await this.getUserInfo();
  }

  loginOut() {
    AuthTokenHolder.clearToken();

    window.location.href = "/login";
  }

  user?: User;

  async getUserInfo() {
    let user = await getCurrentUserInfo();

    this.user = user;
  }
}

export default GlobalStore;
